<template>
  <AppBarComponent class="appbar">
    <slot />
  </AppBarComponent>
</template>

<script setup lang="ts">
import { AppBarComponent } from '@syncfusion/ej2-vue-navigations';
</script>

<style scoped>
@media (max-width: 1025px) {
  .appbar {
    width: 99%;
  }
}
@media (min-width: 1025px) {
  .appbar {
    width: 95%;
  }
}

</style>
